import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useIntl } from 'react-intl';
import { useMutation } from '@apollo/client/react';
import { ResendTempPasswordDocument } from 'graphql/generated/graphql';
import { toGraphqlError, withRaw } from 'utils/error';

const useResendTempPassword = (): [(userId: string) => Promise<void>, boolean] => {
  const [resendTempPasswordMutation, { loading }] = useMutation(ResendTempPasswordDocument);
  const { formatMessage: t } = useIntl();
  const resendTempPassword = useCallback(
    async (userId: string) => {
      try {
        await resendTempPasswordMutation({ variables: { userId } });
        toast.success(t({ id: 'invitations.successfully_sent' }));
      } catch (error) {
        const e = withRaw(toGraphqlError(error), error || '');
        toast.error(e.message);
      }
    },
    [resendTempPasswordMutation, t],
  );
  return [resendTempPassword, loading];
};

export default useResendTempPassword;
